module.exports = __webpack_public_path__ + "img/dr.019c9a3f.png";